import { sendAnalytics } from '@audio-network/analytics'
import { PopoverControlButton } from '@audio-network/componentlibrary'
import { Notes, NotesFilled } from '@audio-network/componentlibrary/icons'
import { useTranslation } from 'next-i18next'
import { useRef } from 'react'

import { useActiveProject } from '@/hooks/useActiveProject'

import { NoteProps } from './Note.types'

const Note = ({ track, ...props }: NoteProps): JSX.Element => {
	const { t } = useTranslation(['trackrow'])
	const { project, isEditable } = useActiveProject()

	const popoverControlButtonRef = useRef(null)

	const isOpen = useRef(false)

	const noteId = `note-${track.id}`

	const note = project?.Tracks?.find((t) => t.Id === track.id)?.Notes

	const handleClick = async (): Promise<void> => {
		if (!isOpen.current) {
			sendAnalytics({
				noun: 'Project Note',
				pastTenseVerb: 'Clicked',
				eventParameters: { TrackId: track.id },
			})
		}

		isOpen.current = !isOpen.current
	}

	if (!note && !isEditable) {
		return <Notes color="uiDisabled" />
	}

	const IconComponent = note?.length > 0 ? NotesFilled : Notes

	return (
		<>
			<PopoverControlButton
				popovertarget={noteId}
				onClick={handleClick}
				ref={popoverControlButtonRef}
			>
				<IconComponent title={t('track-actions.notes')} {...props} />
			</PopoverControlButton>
		</>
	)
}

export default Note
